import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPageHero from 'flarum/newvigation/components/IndexPageHero';

export default function addIntroTextToHero() {
	extend(IndexPageHero.prototype, 'items', (items) => {
		const currentRoute = app.current.get('routeName');

		if (currentRoute === 'index') {
			items.add('description', <p className="Hero-description">{app.translator.trans('glowingblue-orell-thalia-common.forum.intro.index')}</p>);
		}

		if (currentRoute === 'reviews') {
			items.add('description', <p className="Hero-description">{app.translator.trans('glowingblue-orell-thalia-common.forum.intro.reviews')}</p>);
		}
	});
}
